require('../vendor/modernizr-custom');
// require('../vendor/instagram');
require('../vendor/jquery.menu-aim');
import enquire from 'enquire.js';

import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import { debounce } from "ceres/app/helper/debounce";
import Vue from "vue";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";

import Swiper from 'swiper';

(function($, window) {

    function NaPoMain() {

        // let initInsta = function(size) {
        //
        //     let $instaContainer = $('#js-instagram-container');
        //
        //     if (App.isHome && $instaContainer.length > 0) {
        //
        //         insta = $instaContainer.instagramApi({
        //             clientId: '3272151226',
        //             accessToken: '3272151226.1677ed0.e3fca0a5f3b34453b3bd0bd437f6e721',
        //             loadMoreSelector: '#js-load-more',
        //             containerSelector: '#js-instagram-container',
        //             elementSelector: '.instagram__element',
        //             maxCount: size,
        //             modal: false,
        //             overlay: true
        //         });
        //
        //     }else if (App.isCategoryView && $instaContainer.length > 0) {
        //
        //         insta = $instaContainer.instagramApi({
        //             clientId: '514302384',
        //             accessToken: '514302384.1677ed0.6c80803b27f24c4ebd93fa1c6b85e36e',
        //             loadMoreSelector: '#js-load-more',
        //             containerSelector: '#js-instagram-container',
        //             elementSelector: '.instagram__element',
        //             maxCount: size,
        //             modal: false,
        //             overlay: true
        //         });
        //     }
        // };

        let NaPoNav = function() {

            let menuClass   = '.megamenu__list';
            let itemClass   = 'megamenu__item'; //without point for hasClass
            let linkClass   = 'megamenu__link'; //without point for hasClass
            let hiddenClass = 'megamenu__sub-menu--hidden'; //without point for hasClass
            let activeClass = 'megamenu__item--active'; //without point for hasClass

            let $menu;

            let init = function () {

                $menu = $(menuClass);

                if($menu.length > 0) {

                    //todo: compare with moex and fix

                    $menu.menuAim({
                        activate: activateSubmenu,
                        deactivate: deactivateSubmenu,
                        exitMenu: exitMenu,
                        submenuDirection: 'below',
                        tolerance: 75,
                        rowSelector: '.megamenu__item',
                        submenuSelector: '.megamenu__sub-menu',
                    })
                }
            };

            let activateSubmenu = function (row) {

                let $row      = $(row),
                    submenuId = $row.data('subMenuId'),
                    $submenu  = $('#' + submenuId);

                $submenu.removeClass(hiddenClass);
                $row.addClass(activeClass);
            };

            let deactivateSubmenu = function (row) {

                let $row      = $(row),
                    submenuId = $row.data('subMenuId'),
                    $submenu  = $('#' + submenuId);

                $submenu.addClass(hiddenClass);
                $row.removeClass(activeClass);

            };

            let exitMenu = function (mouse) {

                if(typeof mouse !== 'undefined') {

                    let $el = $(document.elementFromPoint(mouse.x, mouse.y - 10));

                    if(!$el.hasClass(itemClass) && !$el.hasClass(linkClass)) {
                        return true;
                    }
                }

                return false;
            };

            $(document).ready(function () {
                init();
            });
        };

        const napoNav = new NaPoNav();
        const browser = browserDetect.detect();

        if (browser && browser.name) {
            $('html').addClass(browser.name);
        } else {
            $('html').addClass('unkown-os');
        }

        window.onpopstate = function(event) {
            if (event.state && event.state.requireReload) {
                window.location.reload();
            }
        };

        document.addEventListener('DOMContentLoaded', function() {

            enquire.register('screen and (min-width: 992px)', {
                match: function() {

                    let filterWrapper = document.querySelector('.filter-mobile__list-wrapper');
                    if(filterWrapper) {
                        filterWrapper.classList.remove('filter-mobile__list-wrapper--open');
                    }

                    $('.mobile-navigation').removeClass('mobile-navigation--open');
                    $('body').removeClass('mobile-navigation--visible');

                    $('.search-mobile__input').blur();
                    $('.search-mobile__result-wrapper').hide();
                    $('.mobile-navigation__close-search').hide();
                    $('.mobile-navigation__close').show();

                    $('.attribute-sidebar__sidebar').removeClass('attribute-sidebar__sidebar--open');
                    $('body').removeClass('attribute-sidebar--open');

                    // initInsta(10);

                    if(typeof vueApp.$refs.categoryFilter !== 'undefined') {
                        vueApp.$refs.categoryFilter.closeFilter();
                    }

                },
                unmatch: function () {

                    $('.search__wrapper').hide();
                    $('.js--search__result').hide();
                    $('.shop-nav__search-btn').removeClass('shop-nav__btn--close');
                    $('.search__input').blur();

                    $('.attribute-sidebar__sidebar').removeClass('attribute-sidebar__sidebar--open');
                    $('body').removeClass('attribute-sidebar--open');

                    // initInsta(8);
                },
                setup: function () {
                    if($(document).outerWidth() < 992) {
                        // initInsta(8);
                    }
                }
            });

            //bs dropdown slide up/down
            $('.dropdown').on('show.bs.dropdown', function() {
                $(this).find('.dropdown-menu').first().stop( true, true ).slideDown(200);

                if($(document).outerWidth() >= 992) {

                    let $btn = $('.shop-nav__search-btn');

                    $('.search__wrapper').slideUp(200);
                    $btn.removeClass('shop-nav__btn--close');

                    setTimeout(function () {
                        $('.search__input').blur();
                    }, 200);
                }

                $('.basket-preview').removeClass('basket-preview--open');
                $('body').removeClass('basket-preview--visible');
                $('.shop-nav__btn-basket-preview').removeClass('shop-nav__btn--close');

            });

            $('.dropdown').on('hide.bs.dropdown', function(){
                $(this).find('.dropdown-menu').first().stop( true, true ).slideUp(200);
            });

            $('#js--toggle-text').on('click', function () {
                $('#js--toggle-wrapper').toggleClass('single__description--open');
                $('#js--toggle-text').toggleClass('single__description-btn--open');
            });

            //auto size input
            $.fn.textWidth = function() {

                if (!$.fn.textWidth.fakeEl) {
                    $.fn.textWidth.fakeEl = $('<pre>').hide().appendTo(document.body);
                }

                let text = this.val() || this.attr('placeholder');

                $.fn.textWidth.fakeEl.text(text)
                    .css('font-size', this.css('font-size'))
                    .css('font-weight', this.css('font-weight'))
                    .css('letter-spacing', this.css('letter-spacing'));

                return $.fn.textWidth.fakeEl.width();
            };

            $('.js--width__dynamic').on('input', function() {
                $(this).css({
                    width: $(this).textWidth() + 1
                });
            });

            $('.scroll-top').on('click', function() {
                $('html, body').animate({scrollTop: 0}, 'slow');
            });

            $('.home-slider').each(function () {

                let $this    = $(this);

                if($this.find(".swiper-slide").length === 0){
                    $this.remove();
                }else {
                    let id = $this.data('uid-image-slider');
                    let auto = $this.data('auto-slide') === 1;
                    let delay = $this.data('auto-slide-delay');
                    let config = {
                        loop: auto,
                        navigation: {
                            nextEl: '.home-slider--' + id + ' .swiper-button-next',
                            prevEl: '.home-slider--' + id + ' .swiper-button-prev',
                        }
                    };

                    if (auto) {
                        config.autoplay = {
                            delay: delay
                        }
                    }

                    let homeSlider = new Swiper('.home-slider--' + id + ' .slider--home', config);

                    //custom home pagination
                    $('.home-slider--' + id + ' .home-slider__pagination-element').click(function () {

                        let $this = $(this);
                        let index = $this.data('slide-index');

                        $('.home-slider--' + id + ' .slider--home').find('.home-slider__pagination-element--active').removeClass('home-slider__pagination-element--active');
                        $this.addClass('home-slider__pagination-element--active');

                        if (auto) {
                            homeSlider.slideToLoop(index);
                        } else {
                            homeSlider.slideTo(index);
                        }
                    });

                    homeSlider.on('slideChange', function () {

                        let $slider = $('.home-slider--' + id + ' .slider--home');

                        $slider.find('.home-slider__pagination-element--active').removeClass('home-slider__pagination-element--active');
                        $slider.find('[data-slide-index="' + homeSlider.realIndex + '"]').addClass('home-slider__pagination-element--active');
                    });
                }
            });

            new Swiper('.swiper-container-highlights', {
                slidesPerView: 4,
                spaceBetween: 0,
                freeMode: true,

                breakpoints: {
                    1199: {
                        slidesPerView: 3,
                    },
                    991: {
                        slidesPerView: 'auto',
                    },
                },

                navigation: {
                    nextEl: '.home-highlight__row--2 .swiper-button-next',
                    prevEl: '.home-highlight__row--2 .swiper-button-prev',
                }
            });

            $('.brand-slider').each(function () {

                let id = $(this).data('uid-brand-slider');

                new Swiper('.brand-slider--'+id+' .swiper-container-brands', {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    breakpoints: {
                        1699: {
                            slidesPerView: 3,
                        },
                        991: {
                            slidesPerView: 'auto',
                            freeMode: true,
                        }
                    },

                    navigation: {
                        nextEl: '.brand-slider--'+id+' .swiper-button-next',
                        prevEl: '.brand-slider--'+id+' .swiper-button-prev',
                    }
                });

            });

            if ($('.swiper-container-topheader .swiper-slide').length > 1) {
                new Swiper('.swiper-container-topheader', {

                    loop: true,
                    slidesPerView: 1,
                    autoplay: {
                        delay: 5000,
                    },
                    navigation: {
                        nextEl: '.swiper-container-topheader .swiper-button-next',
                        prevEl: '.swiper-container-topheader .swiper-button-prev',
                    }
                });
            }

        });

        //replace object-fit if not supported
        if(!Modernizr.objectfit) {

            //img fallback styling
            $('.object-fit').addClass('no__object-fit');

            let setObjectFitFallback = function(index) {

                let $img = $('.object-fit--picture').find('img');
                $img.each(function () {

                    let $this = $(this);
                    let $pic  = $this.closest('picture');
                    let src   = $pic.find('source')
                        .eq(index)
                        .attr('srcset');

                    //fallback
                    if(typeof src === 'undefined') {
                        src = $this.attr('src');
                    }

                    $this.closest('.object-fit--picture-fallback')
                        .css('background-image', 'url(' + src + ')')
                        .css('background-size', 'cover')
                        .css('background-position', 'center');

                    $pic.css('opacity', 0);

                })
            };

            //picture tag to background image
            enquire.register('screen and (min-width: 992px)', {
                match: function() {
                    setObjectFitFallback(1);
                },
                unmatch: function () {
                    setObjectFitFallback(0);
                },
                setup: function () {
                    if($(document).outerWidth() < 992) {
                        setObjectFitFallback(0);
                    }
                }
            });
        }

        if(!Modernizr.csscolumns) {
            $('body').addClass('no__column-count');
        }
    }

    window.NaPoMain = new NaPoMain();

})(jQuery, window, document);
